module.exports = __webpack_public_path__ + "static/media/logo4.bf961228.png";